<template>
  <div :id="`${id}-container`" class="wrapper">
    <button
      type="button"
      :aria-label="tooltip"
      :class="['close-button', buttonClass]"
      v-b-tooltip.hover="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
      :title="tooltip"
      @click.prevent="onClick"
    >
    <span class="material-symbols-outlined close-button-icon" :class="iconClass">
      close
    </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'CloseButton',
  props: {
    id: String,
    tooltip: {
      type: String,
      default: 'Close'
    },
    buttonClass: String,
    iconClass: String,
    onClick: Function
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: min-content;
  height: min-content;
}

.close-button {
  color: $iconColor2;
  margin-right: initial !important;
  border-radius: 5px;
  border: none;
  padding: 3px;
  background-color: transparent;
  transition: 0.2s;

  &:hover {
    color: darken($iconColor2, 20%);
  }

  // &:focus {
  //   outline: none !important;
  //   box-shadow: $btn-focus-box-shadow;
  //   color: darken($iconColor2, 20%);
  // }
}

.close-button-icon {
  display: block;
  font-size: 26px;
  font-weight: 600;
}
</style>
